$('.article-cat-btn').click(function (e) {
  e.preventDefault();
  let more = $('.article-cat-btn').attr('data-more');
  let less = $('.article-cat-btn').attr('data-less');
  $('.article-cat-list').toggleClass('active');
  $('.article-cat-btn').toggleClass('active')
  if ($('.article-cat-list').hasClass('active')) {
    $('.article-cat-btn span').text(less)
  } else {
    $('.article-cat-btn span').text(more)
  }
});

let title = $('*[data-number]')
if (title) {
  let li = "";
  Array.from(title).forEach((item, index) => {
    let number = $(item).data('number');
    let text = $(item).text();
    let tagName = item.localName;
    $(item).attr('id', number)
    if (tagName == 'h2') {
      li += `<li class="lv1"><a href="#${number}">${text}</a></li>`
    } else if(tagName == 'h3'){
      li += `<li class="lv2"><a href="#${number}">${text}</a></li>`
    }
  })
  $('.article-cat-list').append(li)
}
$('.article-cat-list li a').click(function () {
  $(this).parent().addClass('active')
  $(this).parent().siblings().removeClass('active')
  let id = $(this).attr('href');
  $("html, body").animate({
    scrollTop: $(id).offset().top - 112
  }, {
    duration: 500,
    easing: "swing"
  });
  return false;
})